<template>
  <div class="d-flex justify-content-end">
    <McTableFilter
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      @submit="handleInput"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="drivers"
            :label="$t('global.driver')"
            :placeholder="$t('global.driver')"
            :multiple="true"
            trackBy="userId"
            :displayedBy="'fullname'"
            :tableFields="driverTableField"
            type="value-help-v2"
            :listGetter="resourcefulQuery.drivers"
            :fullObject="fullObjects['drivers']"
            @update:formValues="updateFormValues({ key: 'drivers', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'drivers', value: $event })"
            :value="formValues.drivers"
          >
          </FormulateInput>
        </div>
        <div v-if="hasScopeFilterVGroupsDriverScore" class="mc-modal__filter-item">
          <FormulateInput
            class="filter-vgroups-driver-score"
            id="vgroups"
            name="vgroups"
            :type="'select-resourceful-v3'"
            :label="$t('report.fields.vehicleGroup')"
            :placeholder="$t('report.fields.vehicleGroup')"
            :multiple="true"
            :displayedBy="'name'"
            :optionsGetter="resourcefulQuery.vgroups"
            :trackBy="'id'"
            :optionLabelFn="({ item }) => item.name"
            :value="formValues.vgroups"
            :fullObject="fullObjects['vgroups']"
            :hasClose="false"
            selectedLabel="name"
            :visibleTagCount="3"
            @update:formValues="updateFormValues({ key: 'vgroups', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'vgroups', value: $event })"
          />
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="finalGrade"
            :label="$t('global.object.index')"
            :value="(formValues.finalGrade = finalGrade)"
          >
            <div class="mc-modal__filter-button-group">
              <button
                type="button"
                @click="filterGrade('all')"
                :class="{ 'mc-modal__filter-button--active': finalGrade.all }"
                class="mc-modal__filter-button"
              >
                {{ $t('global.filter.all') }}
              </button>
              <button
                type="button"
                @click="filterGrade('A')"
                :class="{ 'mc-modal__filter-button--active': finalGrade.A }"
                class="mc-modal__filter-button"
              >
                A
              </button>
              <button
                type="button"
                @click="filterGrade('B')"
                :class="{ 'mc-modal__filter-button--active': finalGrade.B }"
                class="mc-modal__filter-button"
              >
                B
              </button>
              <button
                type="button"
                @click="filterGrade('C')"
                :class="{ 'mc-modal__filter-button--active': finalGrade.C }"
                class="mc-modal__filter-button"
              >
                C
              </button>
              <button
                type="button"
                @click="filterGrade('D')"
                :class="{ 'mc-modal__filter-button--active': finalGrade.D }"
                class="mc-modal__filter-button"
              >
                D
              </button>
              <button
                type="button"
                @click="filterGrade('E')"
                :class="{ 'mc-modal__filter-button--active': finalGrade.E }"
                class="mc-modal__filter-button"
              >
                E
              </button>
            </div>
          </FormulateInput>
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="driverStatus"
            :label="$t('master.form.driver.driverStatus.text')"
            :value="(formValues.driverStatus = driverStatus)"
          >
            <div class="mc-modal__filter-button-group">
              <button
                type="button"
                @click="filterStatus('active')"
                :class="{ 'mc-modal__filter-button--active': driverStatus.active }"
                class="mc-modal__filter-button"
              >
                {{ $t('global.active') }}
              </button>
              <button
                type="button"
                @click="filterStatus('inactive')"
                :class="{ 'mc-modal__filter-button--active': driverStatus.inactive }"
                class="mc-modal__filter-button"
              >
                {{ $t('global.nonActive') }}
              </button>
            </div>
          </FormulateInput>
        </div>
      </template>
    </McTableFilter>

    <div class="ms-2">
      <McButton
        v-if="isSelected"
        @click="showDeleteModal"
        :variant="'secondary-red'"
        :text="$t('global.delete')"
        icon="icon-outline_trash"
      />
    </div>
  </div>
</template>

<script>
import McTableFilter from '@/components/McTableFilter'
import McButton from '@/components/McButton'
import { GET_EMPLOYEES_PAGINATED } from '@/services/api/master/employees'
import { GET_VEHICLE_GROUPS } from '@/services/api/driverscore/score'

import { mapGetters } from 'vuex'

export default {
  components: {
    McTableFilter,
    McButton,
  },

  props: {
    activeFilters: {
      required: true,
    },
    handleChangeActiveFilters: {
      type: Function,
    },
    isSelected: {},
    showDeleteModal: {},
  },

  data() {
    return {
      finalGrade: {
        all: true,
        A: false,
        B: false,
        C: false,
        D: false,
        E: false,
      },
      driverStatus: {
        active: true,
        inactive: false,
      },
      finalGradeFilter: [],
    }
  },

  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    driverTableField() {
      return [
        {
          label: this.$t('global.driver'),
          key: 'fullname',
          isSortable: true,
          isRedirectable: true,
        },
      ]
    },

    hasScopeFilterVGroupsDriverScore() {
      return this.hasAccessAll(['b4b-filter-grup-kendaraan-penilaian-pengemudi:read'])
    },

    resourcefulQuery() {
      return {
        drivers: async (opts) => {
          let result = {}
          const filter = {
            pagination: {
              page: opts?.page,
              show: opts?.limit,
            },
            search: opts?.search,
            orderBy: opts.sorts,
          }

          const res = await this.$apollo.query({
            query: GET_EMPLOYEES_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                isDriver: true,
              },
            },
          })

          const employees = res.data.employeesPaginated.employeesPaginated

          result = {
            metadata: {
              total_count: employees.pagination.total,
              page: employees.pagination.page,
            },
            data: {
              paginated_result: employees.data,
            },
          }

          return result
        },
        vgroups: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts?.search,
          }

          const res = await this.$apollo.query({
            query: GET_VEHICLE_GROUPS,
            fetchPolicy: 'no-cache',
            variables: { filter },
          })

          const vehicleGroups = res.data.vgroupsPaginated.vgroups

          return {
            metadata: {
              total_count: vehicleGroups.pagination.total,
              page: vehicleGroups.pagination.page,
            },
            data: {
              paginated_result: vehicleGroups.data,
            },
          }
        },
      }
    },

    parseFilterDataMappings() {
      return {
        drivers: 'drivers',
        finalGrade: 'finalGrade',
        driverStatus: 'driverStatus',
        vgroups: 'vgroups',
      }
    },
  },

  methods: {
    handleInput(value) {
      value.map((item) => {
        if (item.values === null) {
          if (item.key === 'drivers') item.values = []
          if (item.key === 'finalGrade') {
            this.finalGrade = {
              all: true,
              A: false,
              B: false,
              C: false,
              D: false,
              E: false,
            }
            item.values = this.finalGrade
          }
          if (item.key === 'driverStatus') {
            this.driverStatus = {
              active: true,
              inactive: false,
            }
            item.values = this.driverStatus
          }
        }
      })

      this.$emit('handleChangeActiveFilters', value)
    },

    filterGrade(key) {
      if (key == 'all') {
        this.finalGrade = {
          all: true,
          A: false,
          B: false,
          C: false,
          D: false,
          E: false,
        }
      } else {
        this.finalGrade.all = false
        this.finalGrade[key] = !this.finalGrade[key]
        let obj = { ...this.finalGrade }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })

        if (objArr.length === 5 || objArr.length === 0) {
          this.finalGrade = {
            all: true,
            A: false,
            B: false,
            C: false,
            D: false,
            E: false,
          }
          return
        }
      }
    },

    filterStatus(key) {
      this.driverStatus[key] = !this.driverStatus[key]
      let obj = { ...this.driverStatus }
      let objArr = []
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(true)
        }
      })
    },
  },
}
</script>
<style lang="scss">
.filter-vgroups-driver-score {
  .multiselect__element {
    .multiselect__option--highlight {
      color: $white !important;
    }
  }
  .multiselect__element:hover {
    span {
      color: $white !important;
    }
  }
}
</style>
